<template>
  <div class="w-full max-w-[360px] flex flex-col items-center justify-center gap-4 p-4">
    <!-- <img src="@/assets/ginger-logo.svg" class="logo" /> -->
    <h2 class="text-xl">Войдите в аккаунт</h2>
    <div class="flex flex-col w-full">
      <IftaLabel class="w-full mb-2">
        <InputText id="login" v-model="login" variant="filled" class="w-full mb-2" />
        <label for="login">Login</label>
      </IftaLabel>
      <IftaLabel class="w-full" >
        <Password v-model="password" inputId="password" :feedback="false" variant="filled" toggleMask class="w-full" />
        <label for="password">Password</label>
      </IftaLabel>
    </div>
    <Button label="Log in" @click="makeLogin" />
  </div>
</template>


<script>
import { AuthService } from "@/services/auth.service";
import { UsersService } from '@/services/users.service';
import Button from 'primevue/button';
import InputText from 'primevue/inputtext';
import FloatLabel from 'primevue/floatlabel';
import IftaLabel from 'primevue/iftalabel';
import Password from 'primevue/password';
//import { appendAlert } from '@/plugins/alert';
import { useLoginSuccess } from '@/composables/useLoginSuccess';

export default {
  name: "Login",
  components: {
    Button,
    InputText,
    FloatLabel,
    IftaLabel,
    Password,
  },
  data() {
    return {
      login: "",
      password: "",
      error: "",
    };
  },

  methods: {    
    async makeLogin() {
      try {
        await AuthService.makeLogin({
          login: this.login,
          password: this.password,
        });

        this.error = "";

        await this.$store.dispatch("user/getCurrent", { from: 'LoginPage' });        

        const { onLoginSuccess } = useLoginSuccess(this.$store, this.$router);
        await onLoginSuccess();        

      } catch (error) {
        console.log("ошибка авторизации");
        console.log(error);
      }
    },

    // async getUserInfo() {        
    //     try {            
    //         const userInfo = await UsersService.getCurrent();                           
    //         return userInfo.data;
    //     } catch (e) {            
    //         this.error = e.message
    //         console.log(e)
    //         return null;        
    //     }                 
    //   },
  },
};
</script>


<style scoped>

.logo {
  width: 60px;
  height: 60px;
  flex: none;
  order: 0;
  flex-grow: 0;
}


:deep(.p-password) {
  width: 100% !important;
}

:deep(.p-inputtext) {
  width: 100% !important;
}
</style>